import React from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import { BaseAIAssistantButton } from '../BaseAIAssistantButton';

const noop = () => undefined;

/**
 * AI Accessibility Assistant Button for use in view mode
 *
 * Will add custom actions and more later in future MRs
 */
export const AIA11yAssistantButton = () => (
    <BaseAIAssistantButton title={_('Ask AI')} onClick={noop} />
);
